var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1712_25809)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 11.8865C22 17.9616 17.0751 22.8865 11 22.8865C4.92487 22.8865 0 17.9616 0 11.8865C0 5.81134 4.92487 0.886475 11 0.886475C17.0751 0.886475 22 5.81134 22 11.8865ZM11.3942 9.00716C10.3243 9.45217 8.18596 10.3732 4.97924 11.7704C4.45851 11.9774 4.18574 12.18 4.1609 12.3781C4.11894 12.7128 4.53815 12.8447 5.10901 13.0242C5.18667 13.0486 5.26712 13.0739 5.34961 13.1007C5.91125 13.2833 6.66676 13.4969 7.05951 13.5053C7.41578 13.513 7.81342 13.3662 8.25242 13.0647C11.2486 11.0422 12.7952 10.02 12.8923 9.99793C12.9608 9.98238 13.0557 9.96283 13.12 10.02C13.1844 10.0772 13.178 10.1854 13.1712 10.2145C13.1297 10.3915 11.4841 11.9214 10.6325 12.7131C10.367 12.9599 10.1787 13.135 10.1402 13.175C10.054 13.2645 9.96612 13.3493 9.88165 13.4307C9.35987 13.9337 8.96859 14.3109 9.90331 14.9269C10.3525 15.2229 10.712 15.4677 11.0705 15.7119C11.4622 15.9786 11.8528 16.2446 12.3581 16.5758C12.4869 16.6602 12.6099 16.7479 12.7296 16.8333C13.1854 17.1582 13.5949 17.4501 14.1007 17.4036C14.3946 17.3765 14.6983 17.1001 14.8525 16.2758C15.2169 14.3277 15.9332 10.1067 16.0987 8.36737C16.1132 8.21498 16.095 8.01995 16.0803 7.93433C16.0657 7.84872 16.035 7.72674 15.9238 7.63644C15.792 7.5295 15.5885 7.50695 15.4975 7.50855C15.0838 7.51584 14.449 7.73656 11.3942 9.00716Z",
    fill: "#403B37"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1712_25809"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0 0.886475)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.918e082e53694c5c7c259c370d55a69b.svg";
export { ForwardRef as ReactComponent };